import { useState } from 'react'
import { RiArrowUpSLine, RiArrowDownSLine } from '@remixicon/react'
import PackageIcon from 'assets/package.png'
import SorterChuteStateChip from 'orders/presentation/components/atoms/SorterChuteStateChip/SorterChuteStateChip'
import { AppTable } from 'components/molecules/AppTable/AppTable'
import { ClassificationRuleView } from 'orders/infrastructure/adapters/ClassificationOrderAdapter'
import OrderSummaryPill from 'orders/presentation/components/molecules/OrderSummaryPill/OrderSummaryPill'
import { RuleIndexBadge } from 'components/atoms/RuleIndexBadge/RuleIndexBadge'

interface Props {
    ruleView: ClassificationRuleView
}

const TABLE_HEADERS = [
    { id: 'container', title: 'Contenedor', className: 'text-center px-6 py-3 text-xs font-medium text-[#64748B] w-[316px]' },
    { id: 'state', title: 'Estado operativo', className: 'text-center px-6 py-3 text-xs font-medium text-[#64748B] w-[316px]' },
    { id: 'packages', title: 'Paquetes', className: 'text-center px-6 py-3 text-xs font-medium text-[#64748B] w-[316px]' },
]

export default function ClassificationRuleRow({ ruleView }: Props) {
    const [open, setOpen] = useState(true)
    const { name, sequence, containers, totalPackages } = ruleView

    return (
        <div className="rounded-xl overflow-hidden">
            <button
                type="button"
                onClick={() => setOpen((o) => !o)}
                className="w-full flex items-center justify-between px-5 py-3 bg-white"
                aria-expanded={open}
            >
                <div className="flex items-center gap-2">
                    {open
                        ? <RiArrowUpSLine size={18} className="text-[#64748B]" />
                        : <RiArrowDownSLine size={18} className="text-[#64748B]" />
                    }
                    <span className="text-sm font-semibold text-[#1E293B] uppercase tracking-wide">
                        {name}
                    </span>
                    {sequence != null && <RuleIndexBadge index={sequence} />}
                </div>

                <div className="flex items-center gap-1.5">
                    <img src={PackageIcon} alt="paquetes" className="w-5 h-5" />
                    <span className="text-2xl font-semibold leading-7 text-right text-[#475569]">{totalPackages}</span>
                </div>
            </button>

            {open && (
                <div className="px-3 pb-3 bg-white">
                    <AppTable dataHead={TABLE_HEADERS}>
                        <tbody>
                            {containers.map((container) => (
                                <tr key={container.id}>
                                    <td className="px-6 py-4 border-t border-[#E2E8F0] text-center">
                                        <OrderSummaryPill containerCode={container.code} centered />
                                    </td>
                                    <td className="px-6 py-4 border-t border-[#E2E8F0] text-center">
                                        <SorterChuteStateChip state={container.status} />
                                    </td>
                                    <td className="px-6 py-4 border-t border-[#E2E8F0] text-center">
                                        <span className="text-base font-semibold text-[#1E293B]">
                                            {container.packageCount}
                                        </span>
                                    </td>
                                </tr>
                            ))}
                            {containers.length === 0 && (
                                <tr>
                                    <td colSpan={3} className="px-6 py-6 text-center text-sm text-[#94A3B8] border-t border-[#E2E8F0]">
                                        Sin contenedores asignados
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </AppTable>
                </div>
            )}
        </div>
    )
}
